import { VStack, Container } from "@chakra-ui/react";
import { FC } from "react";
import { BlockContainer } from "src/atoms";
import Renderer from "src/lib/renderer";

import { Element } from "@prismicio/react";
import { heading2 } from "src/lib/renderer/elements/headings";
import { Slice } from "../types";
import { getBottomPadding } from "./utils";
import { shouldDisplayBlock } from "../utils";
import paragraph from "src/lib/renderer/elements/paragraph";

const BlockTitle: FC<Gatsby.PageBlockTitleFragment & { nextBlock: Slice }> = ({
  primary,
  nextBlock,
}) => {
  if (!primary) throw Error();

  const { content, experiment_variant: experimentVariant } = primary;

  const bottomPadding = getBottomPadding(nextBlock);

  const shouldShow = shouldDisplayBlock(experimentVariant);
  if (!shouldShow) {
    return null;
  }

  return (
    <BlockContainer paddingBottom={bottomPadding}>
      <Container variant="heading" paddingBottom={{ md: "space-8" }}>
        <VStack
          spacing="space-24"
          sx={{
            "h2,h3": {
              marginBottom: 0,
            },
          }}
        >
          <Renderer
            field={content}
            overrides={{
              // Applying heading-2 typography styles to all the other headings. Have to disable the availability of other heading type from the prismic custom type and then remove this override in the future
              [Element.heading3]: heading2,
              [Element.heading4]: heading2,
              [Element.paragraph]: (args) =>
                paragraph({
                  ...args,
                  overrideProps: {
                    variant: "subtitle",
                    color: "text-subheader",
                  },
                }),
            }}
          />
        </VStack>
      </Container>
    </BlockContainer>
  );
};

export default BlockTitle;
